import React, { useState } from 'react'
import { Icon } from 'antd'

export const ProductImage = ({ imageUrl, size }) => {
    const [isError, setIsError] = useState(false)

    if (isError || !imageUrl) {
        return (
            <div
                style={{
                    width: size,
                    height: size,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#ccc',
                    borderRadius: '4px',
                }}>
                <Icon
                    type="user"
                    style={{ fontSize: size * 0.45, color: 'white' }}
                />
            </div>
        )
    }

    return (
        <img
            style={{
                width: size,
                height: size,
                objectFit: 'cover',
                display: 'block',
                borderRadius: '4px',
                backgroundColor: '#ccc',
            }}
            src={imageUrl}
            referrerPolicy="no-referrer"
            onError={() => setIsError(true)}
            alt="Product image"
        />
    )
}
